export interface IIntegration {
    _id?: string;
    name: string;
    adserver: string;
    username?: string;
    password?: string;
    host?: string;
}

export const initialIntegrationObj: IIntegration = {
    name: '',
    adserver: 'xroads',
    host: '',
}; 